import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge"

const REFRESH_DELAY_MS = 100

// Shows the dropdown as nav-bar menu in the native app; selecting an entry clicks the matching link.
// Entries that Turbo re-renders later (e.g. table settings) are announced again, so the menu follows the page.
export default class extends BridgeComponent {
  static component = "menu"

  connect() {
    super.connect()

    this.sendMenu()
    this.observer = new MutationObserver(() => this.scheduleRefresh())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.refreshTimer)
    this.send("disconnect", { title: null, slot: this.bridgeElement.bridgeAttribute("slot"), items: [] })
    super.disconnect()
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimer)
    this.refreshTimer = setTimeout(() => this.sendMenu(), REFRESH_DELAY_MS)
  }

  sendMenu() {
    // Only an explicit title, the element text of a container would join all entries
    const title = this.bridgeElement.bridgeAttribute("title")
    const slot = this.bridgeElement.bridgeAttribute("slot")
    const items = this.items.map((item, index) => ({
      title: item.title,
      index,
      group: item.bridgeAttribute("group"),
      icon: item.bridgeAttribute("icon"),
      destructive: item.bridgeAttribute("destructive") === "true",
      active: item.hasClass("active"),
    }))

    this.send("connect", { title, slot, items }, (message) => {
      this.items[message.data.selectedIndex]?.click()
    })
  }

  get items() {
    return Array.from(this.element.querySelectorAll("[data-bridge-menu-item]")).map(
      (element) => new BridgeElement(element)
    )
  }
}
